module.exports = __webpack_public_path__ + "img/icon2.c6a316ae.png";